import { CREATE_Project, REMOVE_Project } from "./actions";
import { loadFromLocalStorage, saveToLocalStorage } from "../../../../../utils/localStorage";

export const projects = (state = loadFromLocalStorage(CREATE_Project, []), action) => {
    const { type, payload } = action;
    switch (type) {
        case CREATE_Project: {
            const { project } = payload;
            const newProject = { project };
            const updatedState = state.concat(newProject);
            saveToLocalStorage(CREATE_Project, updatedState); // Save updated state to local storage
            return updatedState;
        }
        case REMOVE_Project: {
            const { project } = payload;
            const updatedState = state.filter(obj => obj.project !== project);
            saveToLocalStorage(CREATE_Project, updatedState); // Save updated state to local storage
            return updatedState;
        }
        default:
            return state;
    }
};
